import styled from 'styled-components';
import waterMarkBackgroundUrlDark from 'src/assets/images/watermark-dark-evolutive-background.svg';

export const Container = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
  margin: 0 40px;
`;

export const Content = styled.section`
  display: flex;
  padding: 25px 15px;

  .titleWrapper {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
`;

export const ContentLeft = styled.aside`
  display: flex;
  flex-direction: column;
  width: 50%;
  border-right: 1px solid ${props => props.theme.colors.cardContainerEvolutiveCross};
  padding-right: 24px;

  .leftTitle {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin: 0 0 0 8px;
    color: ${props => props.theme.colors.text.default};
  }
`;

export const ContentRight = styled.aside`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-left: 24.5px;

  .rightTitle {
    font-weight: 700;
    font-size: 16px;
    line-height: 19px;
    margin: 0 0 0 8px;
    color: ${props => props.theme.colors.text.default};
  }

  h3 {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #A1B4C4;
    margin: 0 0 0 8px;
  }
`;

export const BeforeCombineCard = styled.div`
  height: 259px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${waterMarkBackgroundUrlDark});
`;

export const WaterMartkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 47px 49px 47px 43.16px;
  align-items: center;
`

export const WaterMarkTitle = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
    margin: 0;
  }

  span {
    display: inline-block;
    height: 1px;
    width: 82px;
    margin: 16px 0;
    background-color: #00BEC1;
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #D6D8DB;
    width: 337.44px;
    margin: 0;
  }

`

export const WaterMark = styled.img`
  max-width: 175px;
  max-height: 175px;
  opacity: ${(props) => (props.theme.title === 'dark' ? 0.7 : 0.3)};
`;